import { always, anyPass, cond, contains, filter, isEmpty, keys, pipe, reduce, T } from 'ramda';
import { contained } from 'ramda-adjunct';
import { NameSpace } from '../../../constants/NameSpace';
import {
  ALL_ART_STORE_MEDIA_TYPES_SELECTED,
  ALL_DIGITAL_PRODUCT_MEDIA_TYPES_SELECTED,
  ALL_NON_SECURE_MEDIA_TYPES_SELECTED,
  ALL_WIX_MUSIC_MEDIA_TYPES_SELECTED,
  ALL_WIX_VIDEO_MEDIA_TYPES_SELECTED,
  NONE_ART_STORE_MEDIA_TYPES_SELECTED,
  NONE_DIGITAL_PRODUCT_MEDIA_TYPES_SELECTED,
  NONE_NON_SECURE_MEDIA_TYPE_SELECTED,
  NONE_WIX_MUSIC_MEDIA_TYPES_SELECTED,
  NONE_WIX_VIDEO_MEDIA_TYPES_SELECTED,
  MEDIA_TYPE_ALL_SELECTED,
  ALL_PORTFOLIO_MEDIA_TYPES_SELECTED,
  NONE_PORTFOLIO_MEDIA_TYPES_SELECTED,
  NONE_LOGOS_MEDIA_TYPES_SELECTED,
  ALL_LOGOS_MEDIA_TYPES_SELECTED,
} from './constants';
import { TMediaTypes } from './withMediaTypes.types';
import { MediaType } from '../../../constants/MediaType';
import {
  isAllNamespace,
  isArtStoreNamespace,
  isDigitalProductNamespace,
  isWixMusicNamespace,
  isWixVideoNamespace,
} from '../../mmgrSettings/namespace';
import { isLogosNamespace, isPortfolioNamespace } from '../../mmgrSettings/namespace/namespace';

export const getAllSelectedMediaTypes = cond<NameSpace, TMediaTypes>([
  [isWixMusicNamespace, always(ALL_WIX_MUSIC_MEDIA_TYPES_SELECTED)],
  [isWixVideoNamespace, always(ALL_WIX_VIDEO_MEDIA_TYPES_SELECTED)],
  [isArtStoreNamespace, always(ALL_ART_STORE_MEDIA_TYPES_SELECTED)],
  [isDigitalProductNamespace, always(ALL_DIGITAL_PRODUCT_MEDIA_TYPES_SELECTED)],
  [isPortfolioNamespace, always(ALL_PORTFOLIO_MEDIA_TYPES_SELECTED)],
  [isLogosNamespace, always(ALL_LOGOS_MEDIA_TYPES_SELECTED)],
  [isAllNamespace, always(MEDIA_TYPE_ALL_SELECTED)],
  [T, always(ALL_NON_SECURE_MEDIA_TYPES_SELECTED)],
]);

export const getNoneSelectedMediaTypes = cond<NameSpace, TMediaTypes>([
  [isWixMusicNamespace, always(NONE_WIX_MUSIC_MEDIA_TYPES_SELECTED)],
  [isWixVideoNamespace, always(NONE_WIX_VIDEO_MEDIA_TYPES_SELECTED)],
  [isArtStoreNamespace, always(NONE_ART_STORE_MEDIA_TYPES_SELECTED)],
  [isDigitalProductNamespace, always(NONE_DIGITAL_PRODUCT_MEDIA_TYPES_SELECTED)],
  [isPortfolioNamespace, always(NONE_PORTFOLIO_MEDIA_TYPES_SELECTED)],
  [isLogosNamespace, always(NONE_LOGOS_MEDIA_TYPES_SELECTED)],
  [T, always(NONE_NON_SECURE_MEDIA_TYPE_SELECTED)],
]);

export const parseInitiallySelectedMediaTypes = (
  allMediaTypesSelected: TMediaTypes,
  namespace: NameSpace,
  initialMediaTypes: MediaType[],
) => {
  const filteredInitialMediaTypes = pipe<TMediaTypes, MediaType[], MediaType[]>(
    keys,
    filter(contained(initialMediaTypes)),
  )(allMediaTypesSelected);

  if (
    anyPass([isWixMusicNamespace, isWixVideoNamespace, isArtStoreNamespace])(namespace) ||
    isEmpty(filteredInitialMediaTypes)
  ) {
    return allMediaTypesSelected;
  }

  return reduce(
    (mediaTypes, mediaType) => ({ ...mediaTypes, [mediaType]: contains(mediaType, filteredInitialMediaTypes) }),
    allMediaTypesSelected,
    keys(allMediaTypesSelected),
  );
};
